import * as audioFiles from '../audio';
import mosMapping from './mosMapping';
import AudioPlayer from '../AudioPlayer';

const pitchNetURL = 'https://tencent-ailab.github.io/pitch-net/';

function RenderAudio(src) {
  return (<AudioPlayer src={src} />);
}

function RenderAudioWithKey(key) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <div style={{
        marginRight: '15px',
      }}>
        {key}
      </div>
      <AudioPlayer src={mosMapping[key]} />
    </div>
  );
}

function PitchNetLink() {
  return (<a href={pitchNetURL}>PitchNet (Base)</a>);
}

const tableContent = {
  demo: {
    internal: {
      columns: [
        {
          title: 'Target',
          dataIndex: 'target',
        },
        {
          title: PitchNetLink,
          dataIndex: 'base',
          render: RenderAudio,
        },
        {
          title: 'Proposed',
          dataIndex: 'proposed',
          render: RenderAudio,
        },
      ],
      dataSources: {
        VKOW: [
          {
            key: '1',
            target: 'JTAN',
            base: audioFiles.BASE_VKOW_JTAN,
            proposed: audioFiles.PROPOSED_VKOW_JTAN,
          },
          {
            key: '2',
            target: 'JLEE',
            base: audioFiles.BASE_VKOW_JLEE,
            proposed: audioFiles.PROPOSED_VKOW_JLEE,
          },
          {
            key: '3',
            target: 'SAMF',
            base: audioFiles.BASE_VKOW_SAMF,
            proposed: audioFiles.PROPOSED_VKOW_SAMF,
          },
          {
            key: '4',
            target: 'MPOL',
            base: audioFiles.BASE_VKOW_MPOL,
            proposed: audioFiles.PROPOSED_VKOW_MPOL,
          },
          {
            key: '5',
            target: 'MPUR',
            base: audioFiles.BASE_VKOW_MPUR,
            proposed: audioFiles.PROPOSED_VKOW_MPUR,
          },
          {
            key: '6',
            target: 'PMAR',
            base: audioFiles.BASE_VKOW_PMAR,
            proposed: audioFiles.PROPOSED_VKOW_PMAR,
          },
        ],
        ADIZ: [
          {
            key: '1',
            target: 'JTAN',
            base: audioFiles.BASE_ADIZ_JTAN,
            proposed: audioFiles.PROPOSED_ADIZ_JTAN,
          },
          {
            key: '2',
            target: 'JLEE',
            base: audioFiles.BASE_ADIZ_JLEE,
            proposed: audioFiles.PROPOSED_ADIZ_JLEE,
          },
          {
            key: '3',
            target: 'SAMF',
            base: audioFiles.BASE_ADIZ_SAMF,
            proposed: audioFiles.PROPOSED_ADIZ_SAMF,
          },
          {
            key: '4',
            target: 'MPOL',
            base: audioFiles.BASE_ADIZ_MPOL,
            proposed: audioFiles.PROPOSED_ADIZ_MPOL,
          },
          {
            key: '5',
            target: 'MPUR',
            base: audioFiles.BASE_ADIZ_MPUR,
            proposed: audioFiles.PROPOSED_ADIZ_MPUR,
          },
          {
            key: '6',
            target: 'PMAR',
            base: audioFiles.BASE_ADIZ_PMAR,
            proposed: audioFiles.PROPOSED_ADIZ_PMAR,
          },
        ]
      }
    },
    external: {
      columns: [
        {
          title: 'Target',
          dataIndex: 'target',
        },
        {
          title: PitchNetLink,
          dataIndex: 'base',
          render: RenderAudio,
        },
        {
          title: 'Proposed + TP',
          dataIndex: 'proposedTP',
          render: RenderAudio,
        },
      ],
      dataSources: {
        M1: [
          {
            key: '1',
            target: 'JTAN',
            base: audioFiles.BASE_M1_JTAN,
            proposedTP: audioFiles.PROPOSED_TP_M1_JTAN,
          },
          {
            key: '2',
            target: 'JLEE',
            base: audioFiles.BASE_M1_JLEE,
            proposedTP: audioFiles.PROPOSED_TP_M1_JLEE,
          },
          {
            key: '3',
            target: 'SAMF',
            base: audioFiles.BASE_M1_SAMF,
            proposedTP: audioFiles.PROPOSED_TP_M1_SAMF,
          },
          {
            key: '4',
            target: 'MPOL',
            base: audioFiles.BASE_M1_MPOL,
            proposedTP: audioFiles.PROPOSED_TP_M1_MPOL,
          },
          {
            key: '5',
            target: 'MPUR',
            base: audioFiles.BASE_M1_MPUR,
            proposedTP: audioFiles.PROPOSED_TP_M1_MPUR,
          },
          {
            key: '6',
            target: 'PMAR',
            base: audioFiles.BASE_M1_PMAR,
            proposedTP: audioFiles.PROPOSED_TP_M1_PMAR,
          },
        ],
        F2: [
          {
            key: '1',
            target: 'JTAN',
            base: audioFiles.BASE_F2_JTAN,
            proposedTP: audioFiles.PROPOSED_TP_F2_JTAN,
          },
          {
            key: '2',
            target: 'JLEE',
            base: audioFiles.BASE_F2_JLEE,
            proposedTP: audioFiles.PROPOSED_TP_F2_JLEE,
          },
          {
            key: '3',
            target: 'SAMF',
            base: audioFiles.BASE_F2_SAMF,
            proposedTP: audioFiles.PROPOSED_TP_F2_SAMF,
          },
          {
            key: '4',
            target: 'MPOL',
            base: audioFiles.BASE_F2_MPOL,
            proposedTP: audioFiles.PROPOSED_TP_F2_MPOL,
          },
          {
            key: '5',
            target: 'MPUR',
            base: audioFiles.BASE_F2_MPUR,
            proposedTP: audioFiles.PROPOSED_TP_F2_MPUR,
          },
          {
            key: '6',
            target: 'PMAR',
            base: audioFiles.BASE_F2_PMAR,
            proposedTP: audioFiles.PROPOSED_TP_F2_PMAR,
          },
        ],
      }
    }
  },
  mos: {
    internal: {
      columns: [
        {
          title: 'Target',
          dataIndex: 'target',
        },
        {
          title: 'col1',
          dataIndex: 'col1',
          render: RenderAudioWithKey,
        },
        {
          title: 'col2',
          dataIndex: 'col2',
          render: RenderAudioWithKey,
        },
      ],
      dataSources: {
        VKOW: [
          {
            key: '1',
            target: 'JTAN',
            col1: 1,
            col2: 2,
          },
          {
            key: '2',
            target: 'JLEE',
            col1: 3,
            col2: 4,
          },
          {
            key: '3',
            target: 'SAMF',
            col1: 5,
            col2: 6,
          },
          {
            key: '4',
            target: 'MPOL',
            col1: 7,
            col2: 8,
          },
          {
            key: '5',
            target: 'MPUR',
            col1: 9,
            col2: 10,
          },
          {
            key: '6',
            target: 'PMAR',
            col1: 11,
            col2: 12,
          },
        ],
        ADIZ: [
          {
            key: '1',
            target: 'JTAN',
            col1: 13,
            col2: 14,
          },
          {
            key: '2',
            target: 'JLEE',
            col1: 15,
            col2: 16,
          },
          {
            key: '3',
            target: 'SAMF',
            col1: 17,
            col2: 18,
          },
          {
            key: '4',
            target: 'MPOL',
            col1: 19,
            col2: 20,
          },
          {
            key: '5',
            target: 'MPUR',
            col1: 21,
            col2: 22,
          },
          {
            key: '6',
            target: 'PMAR',
            col1: 23,
            col2: 24,
          },
        ]
      }
    },
    external: {
      columns: [
        {
          title: 'Target',
          dataIndex: 'target',
        },
        {
          title: 'col1',
          dataIndex: 'col1',
          render: RenderAudioWithKey,
        },
        {
          title: 'col2',
          dataIndex: 'col2',
          render: RenderAudioWithKey,
        },
      ],
      dataSources: {
        M1: [
          {
            key: '1',
            target: 'JTAN',
            col1: 25,
            col2: 26,
          },
          {
            key: '2',
            target: 'JLEE',
            col1: 27,
            col2: 28,
          },
          {
            key: '3',
            target: 'SAMF',
            col1: 29,
            col2: 30,
          },
          {
            key: '4',
            target: 'MPOL',
            col1: 31,
            col2: 32,
          },
          {
            key: '5',
            target: 'MPUR',
            col1: 33,
            col2: 34,
          },
          {
            key: '6',
            target: 'PMAR',
            col1: 35,
            col2: 36,
          },
        ],
        F2: [
          {
            key: '1',
            target: 'JTAN',
            col1: 37,
            col2: 38,
          },
          {
            key: '2',
            target: 'JLEE',
            col1: 39,
            col2: 40,
          },
          {
            key: '3',
            target: 'SAMF',
            col1: 41,
            col2: 42,
          },
          {
            key: '4',
            target: 'MPOL',
            col1: 43,
            col2: 44,
          },
          {
            key: '5',
            target: 'MPUR',
            col1: 45,
            col2: 46,
          },
          {
            key: '6',
            target: 'PMAR',
            col1: 47,
            col2: 48,
          },
        ]
      }
    }
  }
};

export default tableContent;